<template>
  <nav class="navbar navbar-expand-sm navbar-dark bg-primary bd-navbar heightMedium">
    <router-link :to="{ name: 'home.principal' }" class="navbar-brand" style="display: contents">
      <img src="/img/completo365_logo_circular_transparente_blanco.png" class="brandImage" />
    </router-link>
    <span class="showOnlyInSmallDevice text-white font-weight-bold text-uppercase">{{ currentModuleName }}</span>
    <div class="navbar-header">
      <button
        class="navbar-toggler hidden-lg-u"
        type="button"
        data-toggle="collapse"
        data-target="#app-navbar-collapse"
        aria-controls="app-navbar-collapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >☰</button>
    </div>

    <div class="collapse navbar-collapse" id="app-navbar-collapse">
      <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
        <!-- Authenticated -->
        <template v-if="authenticated && faAuthCheck">
          <v-weirdo-router-link
            :modules="['DiarioController', 'ProgrammingController']"
            :text="$t('binnacles')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['MaterialController', 'ExtraController', 'GarantiaController', 'PaymentController']"
            :text="$t('request')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['ProjectController']"
            :text="$t('projects')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['ContractController', 'InfraContractController']"
            :text="$t('jobs')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['PlanoController', 'PolicyController', 'ConstructionPermitController']"
            :text="$t('permissions')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['PreContratoAdminController', 'MessageController', 'ConversacionController', 'ModeloController', 'CitaController']"
            :text="$t('sales')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['TramiteController']"
            :text="$t('formalities')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['PagoClienteController']"
            :text="$t('payments')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            :modules="['TicketController']"
            :text="$t('tickets')"
          >
          </v-weirdo-router-link>
        </template>
        <!-- Guest -->
        <template v-else>
          <li class="nav-item">
            <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">{{ $t('login') }}</router-link>
          </li>
        </template>
      </ul>

      <!-- Authenticated -->
      <template v-if="authenticated && faAuthCheck">
        <b-row>
          <b-col sm="12">
            <b-input-group>
              <b-form-input type="search" ref="actionSearchesState" :state="actionSearchesState" placeholder="Escriba celula, celular o email" v-model="actionSearchesData" id="search-for-clients" trim></b-form-input>
              <b-input-group-append>
                <b-button variant="success" v-on:click.prevent="_searchForClients">{{ $t('search') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </template>

      <template v-if="authenticated && faAuthCheck">
        <ul class="navbar-nav my-2 my-lg-0">
          <li class="nav-item dropdown">
            <show-notification v-on:pageNotification="_updatePager"></show-notification>
          </li>
          <v-weirdo-router-link
            :modules="['UserController', 'ProviderController', 'RoleController', 'CuentaContableController', 'BancoController', 'AbogadoController', 'ContentTemplateBuilderController']"
            :text="$t('administrations')"
          >
          </v-weirdo-router-link>
          <v-weirdo-router-link
            default-route="settings.profile"
            :text="$t('settings')"
          >
          </v-weirdo-router-link>
        </ul>
      </template>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex'

import { initSW } from '../plugins/push'
import is from '../web/plugins/helper/is'
import ShowNotification from './ShowNotifications'
import { listen } from '../web/plugins/event/listen'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  components: {
    'show-notification': ShowNotification,
  },
  data: () => ({
    page: 1,
    appName: window.config.appName,
    actionSearchesData: '',
    searchPage: 1,
  }),
  computed: {
    ...mapGetters({
      authenticated: 'authCheck',
      authUser: 'authUser',
      faAuthCheck: 'faAuthCheck',
      notifications: 'notifications',
      currentModuleName: 'moduleIndicator',
    }),
    actionSearchesState() {
      return this.actionSearchesData.length > 2 ? true : false
    },
  },
  mounted() {
    this.$nextTick(async function() {
      this.checkStatusMenu()
      this.connectionEcho()
      initSW(null)
    })
  },
  methods: {
    checkStatusMenu() {
      listen(this.$el, 'click', function (e) {
        e.preventDefault()

        const trigger = e.delegateTarget || e.currentTarget
        const originTrigger = is.getNode('#app-navbar-collapse')
        const dropdownToggle = is.hasClass(trigger, 'dropdown-toggle')
        const originToggle = is.hasClass(originTrigger, 'show')

        if (!dropdownToggle && originToggle) {
          is.toggle(originTrigger, 'hide')
        }

        return false
      })
    },
    connectionEcho() {
      if (this.authenticated && this.faAuthCheck) {
        const _this = this
        const echo = _this.connectionToPusherJs()
        if (!_this.checkVariable(echo)) {
          return false
        }

        echo.private(`notification-finished-processes.${_this.authUser.id}`)
          .listen(
            '.App\\Events\\NotificationFinishedProcessesEvent',
            async function (event) {
              const { name, description, routeServer, routeClient, request } = event

              _this.$store.dispatch('getNotifications', { notifications: _this.notifications, page: _this.page })
              _this.$store.dispatch('getEvent', event)

              if (_this.checkVariable(routeClient)) {
                /** @var {Array|String|null} */
                const mixedRequest = _this._verifyJson(request)

                _this.$store.dispatch('signatureGenerationProcess', { name, description, values: mixedRequest, routeServer, routeClient })
              }

              _this.$store.dispatch('pushMessage', { title: name, body: description })
            },
          )

        echo.channel('notification-finished-processes')
          .listen(
            '.App\\Events\\NotificationFinishedProcessesEvent',
            async function (event) {
              _this.$store.commit('GLOBAL_CHARGE_START')
              _this.$store.dispatch('getNotifications', { notifications: _this.notifications, page: _this.page })
              _this.$store.dispatch('getEvent', event)
            },
          )
      }
    },
    _verifyJson(text) {
      try {
        return JSON.parse(text)
      } catch (e) {
        return text
      }
    },
    async _searchForClients() {
      if (this.authenticated && this.faAuthCheck) {
        const _this = this
        const value = _this.actionSearchesData
        const route = _this.getSearchDetail()
        let form = _this.createSearchFilter(route.finderParameters ?? [], value)
        const request = { ...route, ...form }

        _this.$store.dispatch('getSearchResults', { params: { page: _this.searchPage }, request })
      }
    },
    _updatePager(page) {
      this.$set(this.$data, 'page', page)
    },
  },
}
</script>
<style scoped>
@media (max-width: 575.99px) {
  .brandImage {
    width: 3rem;
    padding-left: 0.5rem;
  }
  .showOnlyInSmallDevice {
    font-size: 1.3rem;
    font-family: monospace;
    display: block;
  }
}
@media (min-width: 576px) {
  .brandImage {
    width: 4.5rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
  .showOnlyInSmallDevice {
    display: none;
  }
}

.heightMedium {
  min-height: 3.5rem;
}
.background-selection-signature {
  background-color: gray;
}
.selection-signature:hover {
  cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
